export default __webpack_public_path__ + "static/media/small-vertical.8980eff6.jpg";